const personnelRoutes: any = [
    {
        path: 'personnel',
        meta: { title: 'project_menu.personnel' },
        name: 'personnel',
        component: () => import('@/views/Project/Personnel/views/Index/Index.vue'),
    },
]
export default personnelRoutes
